import reactSelectWithOptions from 'ui/form-elements/ReactSelectHOC';

export const ORGANIZATION_TYPE_OPTIONS = [
   {
      value: '',
      label: 'All',
   }, {
      value: 'ENTERPRISE_CUSTOM',
      label: 'Enterprise',
   }, {
      value: 'ENTERPRISE_FREE',
      label: 'Free',
   }, {
      value: 'REGULAR',
      label: 'Subscription',
   },
];

const SelectOrganizationType = reactSelectWithOptions(
   ORGANIZATION_TYPE_OPTIONS,
);

SelectOrganizationType.defaultProps = {
   required: false,
   value: '',
};

export default SelectOrganizationType;
